/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    bold: false,
    id: {
      value: "1",
      bg: false,
    },
    declaration: {
      value: 0,
      bg: false,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Tổng doanh thu trả trong kỳ",
      bg: false,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "2",
      bg: false,
    },
    declaration: {
      value: 0,
      bg: false,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Doanh thu chưa bao gồm thuế giá trị gia tăng",
      bg: false,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "3",
      bg: false,
    },
    declaration: {
      value: 0,
      bg: false,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Doanh thu tính thuế phần việc được trừ của các Nhà thầu phụ(nếu có)",
      bg: false,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "4",
      bg: true,
    },
    declaration: {
      value: 0,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Doanh thu tính thuế của nhà thầu nước ngoài(4=3-2)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "5",
      bg: true,
    },
    declaration: {
      value: 0,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Số thuế phải nộp của nhà thầu nước ngoài(5=5a+5b)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "5a",
      bg: false,
    },
    declaration: {
      value: 0,
      bg: false,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Thuế giá trị gia tăng",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "5b",
      bg: false,
    },
    declaration: {
      value: 0,
      bg: false,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Thuế thu nhập doanh nghiệp",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "6",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Số thuế đã nộp",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "6a",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Thuế giá trị gia tăng",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "6b",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Thuế thu nhập doanh nghiệp",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "7",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Số thuế còn phải nộp(7=5-6>=7a+7b)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "7a",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Thuế giá trị gia tăng(7a=5a-6a>0)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "7b",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Thuế thu nhập doanh nghiệp(7b=5b-6b>0)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "8",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Số thuế nộp thừa(8=5-6<0=8a+8b)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "8a",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Thuế giá trị gia tăng(8a=5a-6a<0)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "8b",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Thuế thu nhập doanh nghiệp(8b=5b-6b<0)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
];

export default function Table({setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
      <Box style={{ maxWidth: "100%", overflowX: "auto" }}>
        <table style={tableStyle}>
          <thead style={{ background: "#eaeae9" }}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Chi tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="3">
                Kê khai của bên Việt Nam ký hợp đồng
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Ghi chú
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Kê khai</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Quyết toán</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Chênh lệch</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(1)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(2)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(3)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(4)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(5)=(4)-(3)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(6)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.id.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.id.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.value}
                  </Td>
                  {index <= 7 &&
                  <Td
                  rowSpan= {index == 7 ? "9": "1"}
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.declaration.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.declaration.bg ? (
                      row.declaration.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="declaration"
                        value={row.declaration.value}
                        onChange={handleChange}
                        type="number"

                      />
                    )}
                  </Td>}
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.settlement.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.settlement.bg ? (
                      row.settlement.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="settlement"
                        value={row.settlement.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>
                  {index <= 7 &&
                  <Td
                    rowSpan= {index == 7 ? "9": "1"}
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.difference.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.difference.bg ? (
                      index == 7 ? "" : "0"
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="difference"
                        value={row.difference.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>}
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.note.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.note.bg ? (
                      row.note.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="note"
                        value={row.note.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        </Box>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
